import React, { useState } from "react";
import cn from "classnames";
import styles from "./Header.module.sass";
import Icon from "../Icon";
import Search from "./Search";
import User from "./User";
import Notification from "./Notification";
import { useAuth } from "../../contexts/AuthContext";

const Header = ({ onOpen }) => {
  const [visible, setVisible] = useState(false);
  const { isAdmin, isCommercial, isPedagogical } = useAuth();

  const handleClick = () => {
    onOpen();
    setVisible(false);
  };

  return (
    <header className={styles.header}>
      <button className={styles.burger} onClick={() => handleClick()}></button>
      {(isAdmin || isPedagogical) && (
        <>
          <Search className={cn(styles.search, { [styles.visible]: visible })} />
          <button
            className={cn(styles.buttonSearch, { [styles.active]: visible })}
            onClick={() => setVisible(!visible)}
          >
            <Icon name="search" size="24" />
          </button>
        </>
      )}
      <div className={styles.control} onClick={() => setVisible(false)}>
        {(isAdmin || isPedagogical) && <Notification className={styles.notification} />}
        <User className={styles.user} />
      </div>
    </header>
  );
};

export default Header;
